import React from "react";
import { useAuth } from "../context/AuthContext";
import { AlertTriangle, X } from "lucide-react";

/**
 * Phase F.6 iter127 — Global banner that appears when the API host can't be reached
 * properly (DNS misroute → API returns HTML instead of JSON, etc.). Surfaces a clear
 * actionable error instead of letting the page silently blank/logout.
 */
const NetworkErrorBanner = () => {
  const { networkError, clearNetworkError } = useAuth();
  if (!networkError) return null;
  return (
    <div
      data-testid="network-error-banner"
      className="fixed top-0 left-0 right-0 z-[9999] bg-red-600 text-white px-4 py-3 shadow-lg"
    >
      <div className="max-w-5xl mx-auto flex items-start gap-3">
        <AlertTriangle className="h-5 w-5 mt-0.5 flex-shrink-0" />
        <div className="flex-1 text-sm">
          <p className="font-semibold mb-1">Network routing issue detected</p>
          <p className="opacity-95">{networkError.message}</p>
          <p className="opacity-80 text-xs mt-1">
            Diagnostic: open this URL directly in a new tab —{" "}
            <a
              href={`${networkError.host}/health`}
              target="_blank"
              rel="noreferrer"
              className="underline font-mono"
            >
              {networkError.host}/health
            </a>
            . If it shows HTML instead of <code>{`{"status":"healthy"}`}</code>, your DNS is misrouting the API host.
          </p>
        </div>
        <button
          onClick={clearNetworkError}
          aria-label="Dismiss"
          data-testid="network-error-dismiss"
          className="opacity-80 hover:opacity-100"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
};

export default NetworkErrorBanner;
